export default __webpack_public_path__ + "static/media/logo_bns.4fa83938.png";